import { FormattedMessage } from 'react-intl'

import type { ExpandedTagsRowProps } from './ExpandedTagsRow.types'
import { TagBadge } from './TagBadge'

export const ExpandedTagsRow = (props: ExpandedTagsRowProps) => {
  const { tags } = props

  return (
    <div className="Table-details-row">
      <span className="Table-row--expandable-title">
        <FormattedMessage id="Tags" />
      </span>

      {tags.length === 0 ? (
        <FormattedMessage id="Tags_no_tags" />
      ) : (
        <span className="ExpandedTagsRow-tags d-flex flex-grow-1 flex-wrap justify-content-end align-items-center gap-1 ms-4">
          {tags.map(tag => (
            <TagBadge
              key={tag.id}
              color={tag.color}
              name={tag.name}
              onRemove={() => undefined}
              showRemove={false}
            />
          ))}
        </span>
      )}
    </div>
  )
}
